/// <amd-module name="VSSUI/Components/Tabs/TabGroupProviderContext" />
import * as React from "react";
import { ITabGroupProviderContext, ITabGroupProviderProps, ITabGroup } from "VSSUI/Components/Tabs/Tabs.Props";
import { Observer } from "VSSUI/Observer";

export const TabGroupProviderContext = React.createContext<ITabGroupProviderContext>({ groups: [] });

export class TabGroupProvider extends React.Component<ITabGroupProviderProps> {
    public render() {
        return (
            <Observer groups={this.props.providers}>
                {(props: { groups: ITabGroup[] }) => {
                    const groups = props.groups.sort((a, b) => (a.order || 100) - (b.order || 100));
                    return <TabGroupProviderContext.Provider value={{ groups }}>{this.props.children}</TabGroupProviderContext.Provider>;
                }}
            </Observer>
        );
    }
}
